<template>
  <v-dialog v-model="value" persistent max-width="900px">
    <material-card color="primary" :title="title">
        <v-container grid-list-md>
          <v-layout wrap>
            
            <v-flex xs12 text-right>
              <v-textarea
                v-model="console"
                clearable
                rows="15"
                ref="tarea"
                autofocus
                />
            </v-flex>

          </v-layout>
        </v-container>

       

      <v-flex xs12 text-right>
        
        <v-btn
          class="mx-1 font-weight-light"
          color="primary"
          @click="close()">Cancel</v-btn>

        <v-btn class="mx-1 font-weight-light" color="danger" :loading="loading" @click="confirm()">START</v-btn>

      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>

import { post } from "@/api/base_entity"

export default {
  inheritAttrs: false,
  props: {
    value: Boolean,
    items: Array,
    userStatus: Object
  },
  data() {
    return {
      roles: [],
      role_id: null,
      console: '',
      loading: false,
      item: {}
    };
  },
  mounted() {    
    
  },
  watch: {
    value() {
      if(this.items.length == 1) {
        this.item = this.items[0]
      }
    }
  },
  computed: {
    title() {
      if(this.items.length == 1) {
        return "Deploy " + this.item.name
      } else {
        return "Deploy ALL"
      }
    }

  },
  methods: {
   close() {
      this.console = ''
      this.$emit("input", false);
    },
    scrolld() {
      const ta = this.$refs.tarea.$refs.input
      ta.scrollTop = ta.scrollHeight
    },
    confirm() {
      this.loading = true
      this.console = ''
      // this.$emit("input", false);
      
      this.loading = true
      return Promise.all(
        this.items.map(async item => {
          const ret = await post('deploy', item)
          this.console += '\n************** ' + item.name + ' *****************\n' + ret.out + '\n\n'
          this.scrolld()
        })
      ).then(() => {
        this.loading = false
         this.scrolld()
      });
      
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
